import React from 'react'

export const Consistency = ({ className }: { className: SVGElement['className'] }) => (
  <svg
    width="1080"
    zoomAndPan="magnify"
    viewBox="0 0 810 809.999993"
    height="1080"
    preserveAspectRatio="xMidYMid meet"
    version="1.0"
    className={className}
  >
    <defs>
      <clipPath id="144efd1a7e">
        <path
          d="M 390.5625 410.476562 L 419.382812 410.476562 L 419.382812 438.851562 L 390.5625 438.851562 Z M 390.5625 410.476562 "
          clipRule="nonzero"
        />
      </clipPath>
      <clipPath id="c4b15c4509">
        <path
          d="M 404.957031 410.476562 C 397.007812 410.476562 390.5625 416.828125 390.5625 424.664062 C 390.5625 432.5 397.007812 438.851562 404.957031 438.851562 C 412.902344 438.851562 419.347656 432.5 419.347656 424.664062 C 419.347656 416.828125 412.902344 410.476562 404.957031 410.476562 Z M 404.957031 410.476562 "
          clipRule="nonzero"
        />
      </clipPath>
    </defs>
    <path
      fill="#ffffff"
      d="M 632.066406 464.804688 C 584.222656 464.804688 560.214844 522.769531 594.042969 556.601562 C 600.273438 562.832031 600.273438 572.9375 594.042969 579.171875 L 559.683594 613.53125 C 553.449219 619.761719 543.34375 619.761719 537.113281 613.53125 C 503.28125 579.699219 445.316406 603.707031 445.316406 651.550781 C 445.316406 660.371094 438.171875 667.511719 429.359375 667.511719 L 380.769531 667.511719 C 371.957031 667.511719 364.808594 660.371094 364.808594 651.550781 C 364.808594 603.648438 306.890625 579.65625 273.015625 613.53125 C 266.785156 619.761719 256.675781 619.761719 250.445312 613.53125 L 216.085938 579.171875 C 209.855469 572.9375 209.855469 562.832031 216.085938 556.601562 C 249.914062 522.769531 225.910156 464.804688 178.0625 464.804688 C 169.246094 464.804688 162.105469 457.660156 162.105469 448.847656 L 162.105469 400.257812 C 162.105469 391.445312 169.25 384.296875 178.0625 384.296875 C 225.910156 384.296875 249.914062 326.335938 216.085938 292.503906 C 209.855469 286.273438 209.855469 276.164062 216.085938 269.933594 L 250.445312 235.574219 C 256.675781 229.339844 266.785156 229.339844 273.015625 235.574219 C 306.84375 269.402344 364.808594 245.398438 364.808594 197.550781 C 364.808594 188.734375 371.957031 181.59375 380.769531 181.59375 L 429.359375 181.59375 C 438.171875 181.59375 445.316406 188.734375 445.316406 197.550781 C 445.316406 245.398438 503.28125 269.402344 537.113281 235.574219 C 543.34375 229.339844 553.449219 229.339844 559.683594 235.574219 L 594.042969 269.933594 C 600.273438 276.164062 600.273438 286.273438 594.042969 292.503906 C 560.214844 326.332031 584.21875 384.296875 632.066406 384.296875 C 640.882812 384.296875 648.023438 391.445312 648.023438 400.257812 L 648.023438 448.847656 C 648.023438 457.660156 640.882812 464.804688 632.066406 464.804688 Z M 252.566406 676.25 L 189.453125 678.765625 C 186.476562 678.675781 183.488281 679.925781 181.457031 682.40625 C 179.21875 685.140625 178.679688 688.710938 179.714844 691.835938 L 194.390625 753.085938 C 195.660156 758.40625 201 761.695312 206.324219 760.429688 C 211.648438 759.164062 214.9375 753.820312 213.671875 748.496094 L 205.230469 713.28125 C 344.414062 809.839844 533.445312 792.699219 653.332031 672.816406 C 780.621094 545.523438 791.085938 341.6875 676.914062 202.34375 C 673.4375 198.09375 667.171875 197.464844 662.921875 200.945312 C 658.671875 204.421875 658.042969 210.6875 661.523438 214.9375 C 769.28125 346.453125 759.394531 538.609375 639.257812 658.746094 C 526.378906 771.628906 348.695312 788.03125 217.378906 697.507812 L 253.34375 696.070312 C 258.816406 695.855469 263.082031 691.246094 262.867188 685.773438 C 262.652344 680.296875 258.039062 676.035156 252.566406 676.25 Z M 557.566406 172.855469 L 620.675781 170.339844 C 623.65625 170.425781 626.640625 169.179688 628.671875 166.699219 C 630.910156 163.960938 631.445312 160.394531 630.414062 157.269531 L 615.738281 96.019531 C 614.472656 90.695312 609.128906 87.40625 603.804688 88.675781 C 598.480469 89.941406 595.191406 95.28125 596.457031 100.605469 L 604.898438 135.820312 C 465.71875 39.265625 276.683594 56.402344 156.800781 176.289062 C 29.507812 303.582031 19.042969 507.417969 133.21875 646.761719 C 136.695312 651.011719 142.960938 651.636719 147.210938 648.160156 C 151.460938 644.683594 152.085938 638.417969 148.609375 634.167969 C 40.851562 502.652344 50.738281 310.492188 170.871094 190.359375 C 283.753906 77.476562 461.433594 61.070312 592.753906 151.597656 L 556.789062 153.03125 C 551.3125 153.246094 547.050781 157.859375 547.265625 163.332031 C 547.480469 168.808594 552.09375 173.070312 557.566406 172.855469 Z M 352.722656 358.136719 L 348.609375 354.027344 C 344.726562 350.140625 338.425781 350.140625 334.539062 354.027344 C 330.65625 357.910156 330.65625 364.210938 334.539062 368.097656 L 338.652344 372.210938 C 342.535156 376.09375 348.835938 376.09375 352.722656 372.210938 C 356.605469 368.324219 356.605469 362.023438 352.722656 358.136719 Z M 321.089844 414.601562 L 315.277344 414.601562 C 309.78125 414.601562 305.324219 419.058594 305.324219 424.550781 C 305.324219 430.046875 309.78125 434.503906 315.277344 434.503906 L 321.089844 434.503906 C 326.585938 434.503906 331.042969 430.046875 331.042969 424.550781 C 331.042969 419.058594 326.585938 414.601562 321.089844 414.601562 Z M 338.652344 476.894531 L 334.539062 481.007812 C 330.65625 484.890625 330.65625 491.191406 334.539062 495.078125 C 338.425781 498.964844 344.722656 498.964844 348.609375 495.078125 L 352.722656 490.964844 C 356.605469 487.082031 356.605469 480.78125 352.722656 476.898438 C 348.835938 473.011719 342.535156 473.011719 338.652344 476.894531 Z M 395.117188 508.527344 L 395.117188 514.34375 C 395.117188 519.835938 399.570312 524.292969 405.066406 524.292969 C 410.5625 524.292969 415.015625 519.835938 415.015625 514.34375 L 415.015625 508.527344 C 415.015625 503.03125 410.5625 498.578125 405.066406 498.578125 C 399.570312 498.578125 395.117188 503.03125 395.117188 508.527344 Z M 457.410156 490.964844 L 461.519531 495.078125 C 465.40625 498.964844 471.707031 498.964844 475.589844 495.078125 C 479.476562 491.195312 479.476562 484.894531 475.589844 481.007812 L 471.480469 476.894531 C 467.59375 473.011719 461.292969 473.011719 457.410156 476.894531 C 453.523438 480.78125 453.523438 487.082031 457.410156 490.964844 Z M 489.039062 434.503906 L 494.855469 434.503906 C 500.351562 434.503906 504.804688 430.046875 504.804688 424.550781 C 504.804688 419.058594 500.351562 414.601562 494.855469 414.601562 L 489.039062 414.601562 C 483.542969 414.601562 479.089844 419.058594 479.089844 424.550781 C 479.089844 430.046875 483.542969 434.503906 489.039062 434.503906 Z M 471.480469 372.210938 L 475.589844 368.097656 C 479.476562 364.210938 479.476562 357.914062 475.589844 354.027344 C 471.707031 350.140625 465.40625 350.140625 461.519531 354.027344 L 457.410156 358.136719 C 453.523438 362.023438 453.523438 368.324219 457.410156 372.210938 C 461.292969 376.09375 467.59375 376.09375 471.480469 372.210938 Z M 415.015625 340.578125 L 415.015625 334.761719 C 415.015625 329.265625 410.5625 324.8125 405.066406 324.8125 C 399.570312 324.8125 395.117188 329.265625 395.117188 334.761719 L 395.117188 340.578125 C 395.117188 346.074219 399.570312 350.527344 405.066406 350.527344 C 410.5625 350.527344 415.015625 346.074219 415.015625 340.578125 Z M 405.066406 438.765625 C 406.410156 438.765625 407.710938 438.582031 408.941406 438.230469 L 431.65625 451.34375 C 436.398438 454.070312 442.457031 452.433594 445.179688 447.6875 C 447.90625 442.945312 446.273438 436.890625 441.527344 434.164062 L 418.851562 421.070312 C 418.203125 418.496094 416.851562 416.203125 415.015625 414.402344 L 415.015625 373.910156 C 415.015625 368.414062 410.5625 363.960938 405.066406 363.960938 C 399.570312 363.960938 395.117188 368.414062 395.117188 373.910156 L 395.117188 414.398438 C 392.484375 416.980469 390.851562 420.574219 390.851562 424.550781 C 390.851562 432.402344 397.214844 438.765625 405.066406 438.765625 Z M 405.066406 297.867188 C 335.101562 297.867188 278.378906 354.585938 278.378906 424.550781 C 278.378906 494.515625 335.101562 551.238281 405.066406 551.238281 C 475.027344 551.238281 531.75 494.515625 531.75 424.550781 C 531.75 354.585938 475.03125 297.867188 405.066406 297.867188 Z M 405.066406 317.765625 C 346.085938 317.765625 298.28125 365.574219 298.28125 424.550781 C 298.28125 483.53125 346.089844 531.339844 405.066406 531.339844 C 464.042969 531.339844 511.851562 483.53125 511.851562 424.550781 C 511.851562 365.574219 464.042969 317.765625 405.066406 317.765625 Z M 405.066406 317.765625 "
      fillOpacity="1"
      fillRule="evenodd"
    />
    <path
      strokeLinecap="round"
      transform="matrix(0, -0.75, 0.75, 0, 395.272044, 429.420934)"
      fill="none"
      strokeLinejoin="miter"
      d="M 13.498747 13.501858 L 74.337291 13.501858 "
      stroke="#27849c"
      strokeWidth="27"
      strokeOpacity="1"
      strokeMiterlimit="4"
    />
    <g clipPath="url(#144efd1a7e)">
      <g clipPath="url(#c4b15c4509)">
        <path
          fill="#27849c"
          d="M 390.5625 410.476562 L 419.382812 410.476562 L 419.382812 438.851562 L 390.5625 438.851562 Z M 390.5625 410.476562 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
    </g>
    <path
      strokeLinecap="round"
      transform="matrix(-0.64422, -0.384032, 0.384032, -0.64422, 440.201093, 456.988005)"
      fill="none"
      strokeLinejoin="miter"
      d="M 13.501991 13.500571 L 53.9267 13.499082 "
      stroke="#27849c"
      strokeWidth="27"
      strokeOpacity="1"
      strokeMiterlimit="4"
    />
    <path
      strokeLinecap="round"
      transform="matrix(-0.00571388, -0.749978, 0.749978, -0.00571388, 395.07174, 524.754138)"
      fill="none"
      strokeLinejoin="miter"
      d="M 13.501999 13.502395 L 21.840815 13.498216 "
      stroke="#27849c"
      strokeWidth="27"
      strokeOpacity="1"
      strokeMiterlimit="4"
    />
    <path
      strokeLinecap="round"
      transform="matrix(-0.547791, -0.512274, 0.512274, -0.547791, 469.64002, 502.367923)"
      fill="none"
      strokeLinejoin="miter"
      d="M 13.498952 13.498147 L 21.841617 13.497615 "
      stroke="#27849c"
      strokeWidth="27"
      strokeOpacity="1"
      strokeMiterlimit="4"
    />
    <path
      strokeLinecap="round"
      transform="matrix(-0.75, 0, 0, -0.75, 505.480754, 434.609758)"
      fill="none"
      strokeLinejoin="miter"
      d="M 13.500381 13.500512 L 21.844132 13.500512 "
      stroke="#27849c"
      strokeWidth="27"
      strokeOpacity="1"
      strokeMiterlimit="4"
    />
    <path
      strokeLinecap="round"
      transform="matrix(-0.75, 0, 0, -0.75, 331.22026, 434.609758)"
      fill="none"
      strokeLinejoin="miter"
      d="M 13.502014 13.500512 L 21.840556 13.500512 "
      stroke="#27849c"
      strokeWidth="27"
      strokeOpacity="1"
      strokeMiterlimit="4"
    />
    <path
      strokeLinecap="round"
      transform="matrix(-0.53033, -0.53033, 0.53033, -0.53033, 345.951987, 379.661485)"
      fill="none"
      strokeLinejoin="miter"
      d="M 13.497818 13.499964 L 21.843151 13.499964 "
      stroke="#27849c"
      strokeWidth="27"
      strokeOpacity="1"
      strokeMiterlimit="4"
    />
    <path
      strokeLinecap="round"
      transform="matrix(0, -0.75, 0.75, 0, 395.056625, 350.949144)"
      fill="none"
      strokeLinejoin="miter"
      d="M 13.499901 13.497417 L 21.843651 13.497417 "
      stroke="#27849c"
      strokeWidth="27"
      strokeOpacity="1"
      strokeMiterlimit="4"
    />
    <path
      strokeLinecap="round"
      transform="matrix(0.515358, -0.544891, 0.544891, 0.515358, 450.351605, 365.871095)"
      fill="none"
      strokeLinejoin="miter"
      d="M 13.498934 13.499351 L 21.843811 13.499681 "
      stroke="#27849c"
      strokeWidth="27"
      strokeOpacity="1"
      strokeMiterlimit="4"
    />
    <path
      strokeLinecap="round"
      transform="matrix(0.515358, -0.544891, 0.544891, 0.515358, 327.107301, 489.148003)"
      fill="none"
      strokeLinejoin="miter"
      d="M 13.500451 13.501801 L 21.841749 13.498346 "
      stroke="#27849c"
      strokeWidth="27"
      strokeOpacity="1"
      strokeMiterlimit="4"
    />
    <path
      strokeLinecap="round"
      transform="matrix(0.749278, -0.0329081, 0.0329081, 0.749278, 178.080815, 679.204666)"
      fill="none"
      strokeLinejoin="miter"
      d="M 13.500441 13.499145 L 99.797096 13.499164 "
      stroke="#27849c"
      strokeWidth="27"
      strokeOpacity="1"
      strokeMiterlimit="4"
    />
    <path
      strokeLinecap="round"
      transform="matrix(-0.17948, -0.728208, 0.728208, -0.17948, 196.866277, 763.48263)"
      fill="none"
      strokeLinejoin="miter"
      d="M 13.498098 13.498627 L 94.921051 13.499382 "
      stroke="#27849c"
      strokeWidth="27"
      strokeOpacity="1"
      strokeMiterlimit="4"
    />
    <path
      strokeLinecap="round"
      transform="matrix(0.749504, -0.0272593, 0.0272593, 0.749504, 546.802176, 152.868)"
      fill="none"
      strokeLinejoin="miter"
      d="M 13.500821 13.498534 L 100.183115 13.498029 "
      stroke="#27849c"
      strokeWidth="27"
      strokeOpacity="1"
      strokeMiterlimit="4"
    />
    <path
      strokeLinecap="round"
      transform="matrix(-0.184868, -0.726859, 0.726859, -0.184868, 613.429005, 169.846535)"
      fill="none"
      strokeLinejoin="miter"
      d="M 14.000829 13.998498 L 94.639537 14.000281 "
      stroke="#27849c"
      strokeWidth="28"
      strokeOpacity="1"
      strokeMiterlimit="4"
    />
  </svg>
)
